import { gql } from "@apollo/client";

export const CORE_PERMIT_REGISTER_FIELDS = gql`
  fragment CorePermitRegisterFields on PermitRegister {
    id
    title
    description
  }
`;
